$(document).ready(function() { 


// For Collection page globo filter app
window.addEventListener('globoFilterRenderCompleted', function () {  
setTimeout(function(){
  // sample cart button ajax
  $(".sample-cart-button").click(function(){  
    
  var proID= $(this).attr("data-id");
  var Sample = "Sample";
  var self = $(this); 
  
        var get_data = {
 		items: [
 		{
 			quantity: 1,
 			id: proID
		}]
		};   
    //  -------------ajax code for the cart----------- 
     $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: get_data,        
        success: function(response) {
            $('.cart-notification-product').html(" ");
            $(".cart-notification").addClass("active");
           var data = response.items;
            data.forEach(pro => {
              var dataAppend = `
              <div class="cart-notification-product__image global-media-settings">
                <img src="${pro.image}" alt="" width="70" height="70" loading="lazy">
             </div>
              <div>
              <h3 class="cart-notification-product__name h4">${pro.title}</h3>
                <dl>
                 <div class="product-option">
                    <dt>Product Type: </dt>
                    <dd>Sample</dd>
                 </dl>
              </div>`;
            $('.cart-notification-product').append(dataAppend);
            });

           $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(cart) {
              // Update the cart count element with the total item count
              $('.cart-count-bubble').text(cart.item_count);
               self.parent().hide();
               self.parent().siblings(".cus-added-cart-btn").show();            
             
            },
            error: function(error) {
              console.log('Error fetching cart:', error);
            }
          });

          
        },
         error: function (error) {     
           self.text("InvalidQuantity");
           self.val("InvalidQuantity");
		}
      });   
  });
}, 3000);
});




// For other page not collection page app
// sample cart button ajax
  $(".sample-cart-button").click(function(){  
   
  var proID= $(this).attr("data-id");
  var Sample = "Sample";
  var self = $(this); 
  
        var get_data = {
 		items: [
 		{
 			quantity: 1,
 			id: proID
		}]
		};   
    //  -------------ajax code for the cart----------- 
     $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: get_data,        
        success: function(response) {
            $('.cart-notification-product').html(" ");
            $(".cart-notification").addClass("active");
           var data = response.items;
            data.forEach(pro => {
              var dataAppend = `
              <div class="cart-notification-product__image global-media-settings">
                <img src="${pro.image}" alt="" width="70" height="70" loading="lazy">
             </div>
              <div>
              <h3 class="cart-notification-product__name h4">${pro.title}</h3>
                <dl>
                 <div class="product-option">
                    <dt>Product Type: </dt>
                    <dd>Sample</dd>
                 </dl>
              </div>`;
            $('.cart-notification-product').append(dataAppend);
              self.parent().hide();
              self.parent().siblings(".cus-added-cart-btn").show();  
            });
          
        },
         error: function (error) {     
           self.text("InvalidQuantity");
           self.val("InvalidQuantity");
		}
      });   
  });



  

// description sample cart button ajax
  $(".description-sample-cart-button").click(function(){  
    
  var proID= $(".description-sample-cart-button-product-id").attr("data-id");
  var Sample = "Sample";
  
         var get_data = {
 		items: [
 		{
 			quantity: 1,
 			id: proID
		}]
		}; 
    //  -------------ajax code for the cart----------- 
     $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: get_data,        
        success: function(response) {
            $('.cart-notification-product').html(" ");
            $(".cart-notification").addClass("active");
           var data = response.items;
            data.forEach(pro => {
              var dataAppend = `
              <div class="cart-notification-product__image global-media-settings">
                <img src="${pro.image}" alt="" width="70" height="70" loading="lazy">
             </div>
              <div>
              <h3 class="cart-notification-product__name h4">${pro.title}</h3>
                <dl>
                 <div class="product-option">
                    <dt>Product Type: </dt>
                    <dd>Sample</dd>
                 </dl>
              </div>`;
            $('.cart-notification-product').append(dataAppend);
            });
        },
         error: function (error) {            
		}
      });   
  });



// if sample button no---  add to cart button ajax for collection page globo
// Normal time
 $(".card-Product-addCart").click(function(){  
    
  var proID= $(this).attr("data-id");  
  var self = $(this); 
  
        var get_data = {
 		items: [
 		{
 			quantity: 1,
 			id: proID
		}]
		};   
    //  -------------ajax code for the cart----------- 
     $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: get_data,        
        success: function(response) {
                    
            $('.cart-notification-product').html(" ");
            $(".cart-notification").addClass("active");
           var data = response.items;
            data.forEach(pro => {
              var dataAppend = `
              <div class="cart-notification-product__image global-media-settings">
                <img src="${pro.image}" alt="" width="70" height="70" loading="lazy">
             </div>
              <div>
              <h3 class="cart-notification-product__name h4">${pro.title}</h3>
                <dl>
                 <div class="product-option">
                    <dt>Product Type: </dt>
                    <dd>Sheet</dd>
                 </dl>
              </div>`;
            $('.cart-notification-product').append(dataAppend);               
            });
               
          
               $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function(cart) {
                  // Update the cart count element with the total item count
                  $('.cart-count-bubble').text(cart.item_count);                                     
                },
                error: function(error) {
                  console.log('Error fetching cart:', error);
                }
              });
          
        },
         error: function (error) {  
            self.text("InvalidQuantity");
           self.val("InvalidQuantity");
		}
      });   
  });

// On filter  
window.addEventListener('globoFilterRenderCompleted', function () {  
setTimeout(function(){
  $(".card-Product-addCart").click(function(){  
  var self = $(this); 
    
  var proID= $(this).attr("data-id");  
         var get_data = {
 		items: [
 		{
 			quantity: 1,
 			id: proID
		}]
		}; 
    //  -------------ajax code for the cart----------- 
     $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: get_data,        
        success: function(response) {
            $('.cart-notification-product').html(" ");
            $(".cart-notification").addClass("active");
           var data = response.items;
            data.forEach(pro => {
              var dataAppend = `
              <div class="cart-notification-product__image global-media-settings">
                <img src="${pro.image}" alt="" width="70" height="70" loading="lazy">
             </div>
              <div>
              <h3 class="cart-notification-product__name h4">${pro.title}</h3>
                <dl>
                 <div class="product-option">
                    <dt>Product Type: </dt>
                    <dd>Sheet</dd>
                 </dl>
              </div>`;
            $('.cart-notification-product').append(dataAppend);
            });

          self.hide();
          self.next(".no-sample-cart").show();
          
               $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function(cart) {
                  // Update the cart count element with the total item count
                  $('.cart-count-bubble').text(cart.item_count);                                     
                },
                error: function(error) {
                  console.log('Error fetching cart:', error);
                }
              });
          
        },
         error: function (error) {            
		}
      });   
  });
}, 3000);
}); 

// END if sample button not have add to cart button ajax for collection page globo

  
  
// ====================MOB STYLE========================
if($(window).innerWidth() <= 767) {
  
$(document).on("click",".footer-block--menu .footer-block__heading ",function() {
    $(this).next().slideToggle();
});

  
}
$(".how--much--calcu--field .calculat--btnsub").click(function(){
$(".enter-amount-qty").addClass('amount-qty-hover');
})
//=================
$('.enter-amount-qty').mouseover(function(){
$(this).addClass('amount-qty-hover');
});
$('.enter-squer-input').mouseover(function(){
$(".enter-amount-qty").addClass('amount-qty-hover');
});

$(".add10percentage-btn").click(function(){
  $(this).parent().toggleClass("is-select-btnn");
  $('.enter-amount-qty').addClass('amount-qty-hover');
}); 
$(document).on("click",".click-popdropdown",function() {
$(".how--much--calculate--wrap").slideToggle();
});






// ====================Sample button hover ========================


$(".product__info-container .sample-cart-button").hover(function(){
    $('.sample-btn-hover-info').show();
},function(){
    $('.sample-btn-hover-info').hide();
});

// cart-quantity update on the cart page
  $(".quantity-popover-container .cart-quantity").click(function(){  
      $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(cart) {
              // Update the cart count element with the total item count
              $('.cart-count-bubble').text(cart.item_count);                                     
            },
            error: function(error) {
              console.log('Error fetching cart:', error);
            }
          });
});



// ==================== Add to cart text change on the product page. ========================

$(".product-form__buttons .product-form__submit").click(function () {
  setTimeout(function() { 
  if ($('.product-form__error-message').text().trim().length > 0) {
    $('.product-form__error-message-custom').text("InvalidQuantity");
  }else{
  $(".product-form__buttons .product-form__submit").addClass("addtocart-text-change");
  $(".product-form__buttons .product-form__submit").find('span').html('<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.7867 2L5.45336 11.3333L1.21094 7.09091" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Added');
  }
  }, 2000);  
});


  
// ==================== Validate only number no text on the product page ========================
$('#enter-squer--txt').on('input', function() {
    var value = $(this).val();
    var numericValue = value.replace(/[^0-9]/g, '');
    $(this).val(numericValue);
}); 
$('.quantity__input').on('input', function() {
    var value = $(this).val();
    var numericValue = value.replace(/[^0-9]/g, '');
    $(this).val(numericValue);
});
  



// ==================== on click over Square foot How much do I need hide Enter square footage ========================

  
 $(".quantity__label").click(function(){
    $(".enter-amount-qty .qty-label").hide();
 });



// ==================== cart notification active body class adding ========================

// $(".sample-cart-button").click(function(){
//   if ($(".cart-notification").hasClass("active")) {
//       $("body").addClass("overflow-hidden");
//   } else {
//       $("body").removeClass("overflow-hidden"); // Optional: remove the class if not active
//   }
// });





  
  
//=================
});
